import React, {Component} from 'react';
import Wrap from './Wrap';
import Back from '../Svg/back';
import Languages from '../../const/languages';
import RGlow from '../Svg/radial-glow-3';

export default class Popup extends Component {
    render () {
        const { children, opened, contentClassSfx, showCloseButton = true, closeHandler } = this.props;

        return (
            <Wrap opened = { opened } >
                <div className = { `popup__content ${contentClassSfx}` }>
                    {children}
                </div>

                { showCloseButton && (
                    <div
                        className = 'btn btn-back'
                        onClick = { closeHandler }
                    >
                        <div className = 'btn__icon'>
                            <Back />
                        </div>

                        <div className = 'btn__label btn__label__bottom'>
                            {Languages.back}
                        </div>

                        <div className = 'btn__glow'>
                            <RGlow />
                        </div>
                    </div>
                )}
            </Wrap>
        );
    }
}
